<div class="zoomable-container" #zoomableContainerRoot [ngClass]="{'active': zoomActive}">
    <div class="zoomable-container-dimmer"></div>
    <div class="zoomable-container-content" [ngStyle]="zoomContainerStyle">
        <button class="zoom-button btn btn btn-primary cursor-pointer" *ngIf="!zoomActive" [ngStyle]="zoomButtonStyle" (click)="zoomOn()">
            <i class="fas fa-fw fa-search-plus"></i>
        </button>
        <button class="zoom-button btn btn btn-primary cursor-pointer" *ngIf="zoomActive" [ngStyle]="zoomButtonStyle" (click)="zoomOff()">
            <i class="fas fa-fw fa-search-minus"></i>
        </button>
        <ng-content></ng-content>
    </div>
</div>
